import React, { useState, useEffect } from 'react';
import { db } from './firebaseConfig';
import { collection, getDocs, query, orderBy, doc, deleteDoc, where } from 'firebase/firestore';
import { toast } from 'react-toastify';
import useReservasStore from './store/reservasStore';

// Imports dos componentes MUI
import {
  Box, Button, Typography, TextField, Paper, Grid,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Link, InputAdornment, CircularProgress,
  TablePagination // <-- ADICIONADO AQUI
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import HistoryIcon from '@mui/icons-material/History';
import SearchIcon from '@mui/icons-material/Search';
import CommentIcon from '@mui/icons-material/Comment';

// Imports dos Modais
import HospedeModal from './HospedeModal';
import VerificarCpfModal from './VerificarCpfModal';
import HistoricoHospedeModal from './HistoricoHospedeModal';
import DetalhesReservaModal from './DetalhesReservaModal';
import ReservaModal from './ReservaModal';
import ObservacaoModal from './ObservacaoModal';

const formatarCPF = (cpf) => {
  if (!cpf) return '';
  const cpfNumerico = cpf.replace(/\D/g, '');
  if (cpfNumerico.length !== 11) return cpf;
  return cpfNumerico.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

const traduzirTipoHospede = (tipo) => {
    switch (tipo) {
      case 'AABB_ARACAJU': return 'AABB Aracaju';
      case 'OUTRA_AABB': return 'Outra AABB';
      case 'NAO_ASSOCIADO': return 'Não Associado';
      default: return tipo;
    }
};

const ConfirmacaoToast = ({ closeToast, onConfirm, message }) => (
    <div>
      <p>{message}</p>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
        <Button size="small" variant="contained" color="error" onClick={() => { onConfirm(); closeToast(); }}>Sim, Excluir</Button>
        <Button size="small" variant="outlined" color="inherit" onClick={closeToast}>Não</Button>
      </div>
    </div>
);

const Hospedes = () => {
  const { chales, fetchInitialData } = useReservasStore();
  const [todosHospedes, setTodosHospedes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isHospedeModalOpen, setIsHospedeModalOpen] = useState(false);
  const [hospedeParaEditar, setHospedeParaEditar] = useState(null);
  const [termoBusca, setTermoBusca] = useState('');
  const [isCpfModalOpen, setIsCpfModalOpen] = useState(false);
  const [isHistoricoModalOpen, setIsHistoricoModalOpen] = useState(false);
  const [hospedeSelecionado, setHospedeSelecionado] = useState(null);
  
  const [isObservacaoModalOpen, setIsObservacaoModalOpen] = useState(false);
  const [voucherBusca, setVoucherBusca] = useState('');
  const [loadingVoucher, setLoadingVoucher] = useState(false);
  const [modalDetalhesAberto, setModalDetalhesAberto] = useState(false);
  const [reservaSelecionada, setReservaSelecionada] = useState(null);
  const [reservaParaEditar, setReservaParaEditar] = useState(null);
  const [modalReservaAberto, setModalReservaAberto] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);


  const fetchHospedes = async () => {
    setLoading(true);
    try {
      const hospedesCollectionRef = collection(db, 'hospedes');
      const q = query(hospedesCollectionRef, orderBy('nome'));
      const querySnapshot = await getDocs(q);
      const hospedesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setTodosHospedes(hospedesData);
    } catch (error) {
      console.error("Erro ao buscar hóspedes: ", error);
      toast.error("Erro ao carregar os hóspedes.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHospedes();
  }, []);

  useEffect(() => {
    setPage(0);
  }, [termoBusca]);

  const handleExcluirHospede = (hospedeId, hospedeNome) => {
    const deletar = async () => {
        try {
            const hospedeDocRef = doc(db, 'hospedes', hospedeId);
            await deleteDoc(hospedeDocRef);
            toast.success(`Hóspede "${hospedeNome}" excluído com sucesso!`);
            setTodosHospedes((hospedesAtuais) => (hospedesAtuais || []).filter(h => h.id !== hospedeId));
        } catch (error) {
            console.error("Erro ao excluir hóspede: ", error);
            toast.error("Ocorreu um erro ao excluir o hóspede.");
        }
    };
    
    toast.warn(
      <ConfirmacaoToast 
        message={`Tem certeza que deseja excluir o hóspede "${hospedeNome}"?`}
        onConfirm={deletar}
      />, {
      position: "top-center",
      autoClose: false,
      closeOnClick: false,
      draggable: false,
    });
  };
  
  const handleSaveHospede = () => {
    fecharHospedeModal();
    fetchHospedes();
  };


  const handleBuscaVoucher = async () => {
    if (!voucherBusca.trim()) { toast.warn("Por favor, digite um código de voucher."); return; }
    setLoadingVoucher(true);
    try {
      const reservasRef = collection(db, 'reservas');
      const q = query(reservasRef, where("codigoVoucher", "==", voucherBusca.trim().toUpperCase()));
      const querySnapshot = await getDocs(q);
      if (querySnapshot.empty) {
        toast.error("Nenhuma reserva encontrada com este voucher.");
      } else {
        const reservaEncontrada = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
        setReservaSelecionada(reservaEncontrada);
        setModalDetalhesAberto(true);
        setVoucherBusca('');
      }
    } catch (error) {
      toast.error("Erro ao buscar reserva pelo voucher.");
      console.error("Erro na busca por voucher:", error);
    } finally {
      setLoadingVoucher(false);
    }
  };
  
  const fecharModalDetalhes = () => { setModalDetalhesAberto(false); setReservaSelecionada(null); };
  const fecharModalReserva = () => { setModalReservaAberto(false); setReservaParaEditar(null); fetchInitialData(); };
  const handleEditarReserva = (reserva) => { fecharModalDetalhes(); setReservaParaEditar(reserva); setModalReservaAberto(true); };
  const handleExcluirReserva = (reservaId) => {
     const deletar = async () => {
        try {
            await deleteDoc(doc(db, "reservas", reservaId));
            toast.success("Reserva excluída com sucesso!");
            fecharModalDetalhes();
            fetchInitialData();
        } catch (error) { toast.error("Erro ao excluir reserva."); }
     };
     toast.warn(<ConfirmacaoToast message="Tem certeza que deseja excluir esta reserva?" onConfirm={deletar}/>, { position: "top-center", autoClose: false, closeOnClick: false });
  };
  
  const handleCpfCheck = async (cpf) => {
    try {
      setIsCpfModalOpen(false);
      if (cpf) {
        const hospedesRef = collection(db, 'hospedes');
        const q = query(hospedesRef, where("cpf", "==", cpf));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
          toast.info("CPF não encontrado. Preencha os dados para um novo cadastro.");
          setHospedeParaEditar({ cpf: cpf }); 
        } else {
          const hospedeEncontrado = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
          setHospedeParaEditar(hospedeEncontrado);
          toast.success("Hóspede encontrado! Editando dados existentes.");
        }
      } else {
        setHospedeParaEditar(null);
      }
      setIsHospedeModalOpen(true);
    } catch (error) {
      console.error("Erro na verificação de CPF:", error);
      toast.error("Ocorreu um erro ao verificar o CPF.");
    }
  };
  
  const abrirModalEdicao = (hospede) => { setHospedeParaEditar(hospede); setIsHospedeModalOpen(true); };
  const fecharHospedeModal = () => { setIsHospedeModalOpen(false); setHospedeParaEditar(null); };
  const abrirModalHistorico = (hospede) => { setHospedeSelecionado(hospede); setIsHistoricoModalOpen(true); };
  const abrirModalObservacao = (hospede) => { setHospedeSelecionado(hospede); setIsObservacaoModalOpen(true); };

  const hospedesFiltrados = (todosHospedes || []).filter(hospede => 
    hospede && hospede.nome && hospede.nome.toLowerCase().includes(termoBusca.toLowerCase())
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  return (
    <Box sx={{ padding: 3, backgroundColor: 'background.default', minHeight: '100vh' }}>
      <Paper sx={{ padding: 2, marginBottom: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
          <Typography variant="h5" component="h1" fontWeight="600">
            Gestão de Hóspedes
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => setIsCpfModalOpen(true)}
          >
            Novo Hóspede
          </Button>
        </Box>
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6}>
                <TextField
                  label="Buscar por nome..."
                  variant="outlined"
                  fullWidth
                  value={termoBusca}
                  onChange={(e) => setTermoBusca(e.target.value)}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                 <TextField
                  label="Buscar por Voucher..."
                  variant="outlined"
                  fullWidth
                  value={voucherBusca}
                  onChange={(e) => setVoucherBusca(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleBuscaVoucher()}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleBuscaVoucher} edge="end" disabled={loadingVoucher}>
                          {loadingVoucher ? <CircularProgress size={24} /> : <SearchIcon />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
            </Grid>
        </Grid>
      </Paper>
      
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="tabela de hóspedes">
          <TableHead>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Nome</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>Celular</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>CPF</TableCell>
              <TableCell sx={{fontWeight: 'bold'}}>Tipo de Hóspede</TableCell>
              <TableCell align="center" sx={{fontWeight: 'bold'}}>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
                <TableRow>
                    <TableCell colSpan={5} align="center">Carregando...</TableCell>
                </TableRow>
            ) : hospedesFiltrados
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((hospede) => (
              <TableRow key={hospede.id} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {hospede.nome}
                </TableCell>
                <TableCell>
                  <Link 
                    href={`https://wa.me/55${hospede.celular?.replace(/\D/g, '')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}
                  >
                    <WhatsAppIcon sx={{ color: '#25D366', marginRight: 1 }} />
                    {hospede.celular}
                  </Link>
                </TableCell>
                <TableCell>{formatarCPF(hospede.cpf)}</TableCell>
                <TableCell>{traduzirTipoHospede(hospede.tipoHospede)}</TableCell>
                <TableCell align="center">
                  <IconButton color="secondary" onClick={() => abrirModalObservacao(hospede)} title="Adicionar/Ver Observação">
                    <CommentIcon />
                  </IconButton>
                  <IconButton color="default" onClick={() => abrirModalHistorico(hospede)} title="Ver Histórico">
                    <HistoryIcon />
                  </IconButton>
                  <IconButton color="primary" onClick={() => abrirModalEdicao(hospede)} title="Editar Hóspede">
                    <EditIcon />
                  </IconButton>
                  <IconButton color="error" onClick={() => handleExcluirHospede(hospede.id, hospede.nome)} title="Excluir Hóspede">
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        
        <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={hospedesFiltrados.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Hóspedes por página:"
        />
      </TableContainer>
      
      {isCpfModalOpen && (
        <VerificarCpfModal
          onClose={() => setIsCpfModalOpen(false)}
          onCpfCheck={handleCpfCheck}
        />
      )}
      
      {isHospedeModalOpen && (
        <HospedeModal 
          open={isHospedeModalOpen}
          onClose={fecharHospedeModal}
          hospedeParaEditar={hospedeParaEditar}
          onSave={handleSaveHospede}
        />
      )}

      {isHistoricoModalOpen && (
        <HistoricoHospedeModal 
          hospede={hospedeSelecionado}
          onClose={() => setIsHistoricoModalOpen(false)}
        />
      )}

      {isObservacaoModalOpen && (
        <ObservacaoModal 
          open={isObservacaoModalOpen}
          hospede={hospedeSelecionado}
          onClose={() => {
            setIsObservacaoModalOpen(false);
            fetchHospedes(); 
          }}
        />
      )}

      {modalDetalhesAberto && (
        <DetalhesReservaModal 
          reserva={reservaSelecionada} 
          onClose={fecharModalDetalhes} 
          onExcluir={handleExcluirReserva} 
          onEditar={handleEditarReserva} 
        />
      )}
      
      {modalReservaAberto && (
        <ReservaModal 
          chale={chales.find(c => c.id === reservaParaEditar.chaletId)} 
          onClose={fecharModalReserva} 
          reservaParaEditar={reservaParaEditar}
        />
      )}
    </Box>
  );
};

export default Hospedes;